export function cloudinaryThumbnail(picture) {
  if (!picture) picture = 'DefaultPic_vhfgvu';
  if (picture.includes('http')) {
    const picSplit = picture.split("/");
    return picSplit.length > 6 ? picture.replace(picSplit[6], "c_fit,w_63,h_44,q_auto,f_auto,fl_progressive,e_bgremoval") : picture;
  }
  return `https://res.cloudinary.com/dmdpovsxf/image/upload/c_fit,w_63,h_44,q_auto,f_auto,fl_progressive,e_bgremoval/${picture}`;
}

export function cloudinaryFull(picture) {
  if (!picture) picture = 'DefaultPic_vhfgvu';
  if (picture.includes('http')) return picture;
  return `https://res.cloudinary.com/dmdpovsxf/image/upload/q_auto,f_auto,fl_progressive/${picture}`;
}
